import React, { useState } from 'react';
import UnitApplicationsHeader from './UnitApplicationsHeader';
import UnitApplications from './UnitApplications';
import UnitOfferManagement from './UnitOfferManagement';
import UnitTours from './UnitTours';
import styles from '../../styles/Building MGMT/UnitApplicationManagement.module.css';

const UnitApplicationManagement = ({ unit, handleBack }) => {
  const [activeTab, setActiveTab] = useState('Applications');

  return (
    <div className={styles.container}>
      <UnitApplicationsHeader
        unit={unit}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleBack={handleBack}
      />

      <div className={styles.contentArea}>
        {activeTab === 'Applications' && <UnitApplications unitId={unit.number} />}
        {activeTab === 'Tours' && <UnitTours unitId={unit.number} />}
        {activeTab === 'Messages' && <div>Messages Management Content</div>}
        {activeTab === 'Offer' && <UnitOfferManagement unitId={unit.number} />}
      </div>
    </div>
  );
};

export default UnitApplicationManagement;
